export default function controller(element, identifier) {
  return Stimulus.getControllerForElementAndIdentifier(element, identifier)
}
